/**
 * Shared table layout tokens — matches UserList / ReportList / AssetTable pattern.
 * Do not use for TaskListView (task grid uses table-fixed and custom layout).
 */

export const tableShell = {
  scrollOuter: "table-scroll w-full min-w-0 max-w-full overflow-hidden",
  scrollInner:
    "scrollbar-container relative max-h-[450px] w-full min-w-0 max-w-full overflow-x-auto overflow-y-auto rounded-xl shadow-lg border border-gray-100",
  table: "min-w-full text-sm text-start text-gray-700",
  thead: "bg-gradient-to-r from-gray-50 to-gray-100 sticky top-0 z-10",
  tbody: "bg-white divide-y divide-gray-100",
  th: "px-3 py-3 text-xs font-semibold uppercase tracking-wide text-gray-600 whitespace-nowrap align-middle",
  td: "px-3 py-3 align-middle text-sm text-gray-700 whitespace-nowrap",
  tr: "hover:bg-gray-50 transition-colors",
  emptyCell: "px-3 py-8 text-center text-gray-500",
  /** Circular checkboxes for table row selection (Security, Stock, PDF Generator, etc.) */
  checkbox:
    "table-checkbox h-4 w-4 shrink-0 cursor-pointer rounded-full border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:ring-offset-0",
};

export const getThemedTableShell = (theme) => {
  const themeClass =
    theme === "dark"
      ? "dark-mode"
      : theme === "high-contrast"
        ? "high-contrast"
        : "";

  const thead =
    theme === "dark"
      ? "text-sm sticky top-0 z-10 whitespace-nowrap dark-mode border-b bg-gray-800 text-gray-300"
      : theme === "high-contrast"
        ? "text-sm sticky top-0 z-10 whitespace-nowrap high-contrast bg-gray-100 text-gray-800"
        : `${tableShell.thead} text-gray-800`;

  return {
    scrollOuter: tableShell.scrollOuter,
    scrollInner: tableShell.scrollInner,
    table: `${tableShell.table} ${themeClass}`.trim(),
    thead,
    tbody: `bg-white divide-y divide-gray-100 ${themeClass}`.trim(),
    th: tableShell.th,
    td: tableShell.td,
    tr: tableShell.tr,
    emptyCell: tableShell.emptyCell,
  };
};
